var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-row-selector-tab"},[_c('div',{staticClass:"font-size-lg mb-2"},[_vm._v("Select table header")]),_c('TableView',{staticClass:"flex-1",attrs:{"headers":_vm.columnDefsFromPreviousSteps,"rows":_vm.rowsFromPreviousSteps,"gridOptions":_vm.gridOptions,"gridListeners":_vm.gridListeners},on:{"onGridReady":_vm.onGridReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }